import i18n from 'src/i18n';
import debug from 'src/debug';

export function parseError(err) {
  if (err instanceof Error) {
    return err.message;
  }
  if (typeof err === 'object') {
    if (err.err) {
      err = err.err;
    }
  }
  if (typeof err === 'object') {
    return i18n.S(err, JSON.stringify(err));
  }
  return err;
}

/**
 * api response error catcher
 * @param response
 * @return {*}
 */
export function parseResponse(response) {
  if (!response || !response.body) {
    throw new Error(i18n.fr('alert.empty_response', {response}));
  }
  let result = response.body;
  if (!result.success) {
    console.error(response);
    return Promise.reject(result);
  }
  return response;
}

export function getCookie(name) {
  let value = "; " + document.cookie;
  let parts = value.split("; " + name + "=");
  if (parts.length == 2) return parts.pop().split(";").shift();
}

export function formatSiUnit(value, units, zeroIndex, base, decimals) {
  decimals = Math.pow(10, decimals);
  let order = Math.floor(Math.log(value) / Math.log(base));
  order = Math.min(Math.max(order + zeroIndex, 0), units.length - 1) - zeroIndex;
  let round = Math.round((value / Math.pow(base, order)) * decimals) / decimals;
  return `${round} ${units[order + zeroIndex]}`;
}

formatSiUnit.BYTE = ['B', 'KB', 'MB', 'GB', 'TB', 'EB'];

formatSiUnit.byte = (value, decimals = 2) => formatSiUnit(value, formatSiUnit.BYTE, 0, 1024, decimals);

export function formatThousands(value, comma) {
  return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, comma || ',');
}

export function uuid(length) {
  let text = "";
  let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  for (let i = 0; i < length; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length));

  return text;
}

export function formatPhone(value) {
  if (typeof value === 'string') {
    value = value.replace(/^(852|853|86)(?=\d)/, '$1-');
  }
  return value;
}

export function apiHost() {
  let url = debug.API_HOST || window.API || 'https://api.ok.care/';
  return url.replace(/\/+$/, '') + '/';
}



// WEBPACK FOOTER //
// ./src/utils.js